import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { pageVariants } from '@yoda/shared';

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

export function PageTransition({ children, className = '' }: PageTransitionProps) {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className={`flex-1 flex flex-col min-h-0 ${className}`}
    >
      {children}
    </motion.div>
  );
}
